"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fahrenheit = exports.Rankine = exports.Celsius = void 0;
var uom_1 = require("uom");
/**
 * The derived unit for Celsius temperature ( <code>℃</code> ).
 * This is a unit of temperature such as the freezing point of water (at one atmosphere of pressure)
 * is 0 ℃, while the boiling point is 100 ℃.
 */
exports.Celsius = uom_1.Unit.plus("Celsius", 273.15, uom_1.BaseUnits.Kelvin);
exports.Rankine = uom_1.Unit.divideNumber("Rankine", 9.0, uom_1.Unit.timesNumber("", 5.0, uom_1.BaseUnits.Kelvin));
exports.Fahrenheit = uom_1.Unit.plus("Fahrenheit", 459.67, uom_1.Unit.divideNumber("", 9.0, uom_1.Unit.timesNumber("", 5.0, uom_1.BaseUnits.Kelvin)));
//# sourceMappingURL=temperature.js.map